import React, { PropTypes } from 'react';
import { Link } from 'react-router';

import { button as defaultStyle, primary as primaryStyle } from '../Button/styles.module.css';

/**
 * Button link presentational component.
 * Styles a link to look like a button.
 **/
const ButtonLink = ({
  children,
  className,
  disabled,
  href,
  primary,
  to,
  ...props
}) => {
  const Component = to ? Link : 'a';
  return (
    <Component
      className={[primary ? primaryStyle : defaultStyle, className].join(' ')}
      {...(to && !disabled) && { to }}
      {...(href && !disabled) && { href }}
      disabled={disabled}
      {...props}
    >
      {children}
    </Component>
  );
};

ButtonLink.propTypes = {
  /**
   * Children contents of button.
   */
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Boolean to disabled button.
   */
  disabled: PropTypes.bool,
  /**
   * String href attribute for external link destinations.
   */
  href: PropTypes.string,
  /**
   * Boolean to style button as primary.
   */
  primary: PropTypes.bool,
  /**
   * String to attribute for internal router destinations.
   */
  to: PropTypes.string,
};

ButtonLink.defaultProps = {
  className: undefined,
  disabled: false,
  href: undefined,
  primary: false,
  to: undefined,
};

export default ButtonLink;



// WEBPACK FOOTER //
// ./app/src/components/ButtonLink/index.jsx